import { render } from "./BuyTickets.vue?vue&type=template&id=5ab0efda&scoped=true"
import script from "./BuyTickets.vue?vue&type=script&lang=js"
export * from "./BuyTickets.vue?vue&type=script&lang=js"

import "./BuyTickets.vue?vue&type=style&index=0&id=5ab0efda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab0efda"]])

export default __exports__